import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core'
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';

import { Observable } from 'rxjs'

import { AddCartEvent, ApiOrder, ApiOrderWrap } from '../models/cart-models';

import { environment } from '../../../environments/environment'
import { applyTranslations } from '../../core/helpers/translations'

const orderUrl = '/orders'

const emptyCart: ApiOrder = {
    lines: [],
    totalOrderLines: 0,
    subTotalPrice: 0,
    totalPrice: 0
}

@Injectable()
export class CartService {

    cartItemAdded$: Observable<any>

    constructor(
        private http: HttpClient,
    ) {
    }

    public getOpenCart(customerId: string, includeExtraCosts: boolean): Observable<ApiOrder> {
      const params = new HttpParams()
        .set('customerId', customerId)
        .set('type', 'cart')
        .set('includeExtraCosts', includeExtraCosts.toString())

        return this.http.get<HttpResponse<ApiOrderWrap>>(
            environment.baseApiUrl + orderUrl,
            {
                observe: 'response',
                params
            }
        ).pipe(
        map(response => response.status === 204
            ? emptyCart : response.body['results'][0] as ApiOrder))
    }

    public createOrder(customerId, event: AddCartEvent): Observable<ApiOrder> {
        return this.http.post<ApiOrder>(
            environment.baseApiUrl + orderUrl,
            {
                lines: [event]
            },
          {
            params: {
              customerId
            }
          }
        ).pipe(map(order => {
            order.lines = order.lines.map(line => {
                line.product = applyTranslations([line.product])[0]
                return line
            })
            return order
        }))
    }

    public setLine(customerId: string, orderId: string, event: AddCartEvent): Observable<ApiOrder> {
      let params = new HttpParams()
        .set('customerId', customerId)

      if (event.includeExtraCosts) {
        params = params.set('includeExtraCosts', event.includeExtraCosts.toString())
      }

      return this.http.post<ApiOrder>(
          `${environment.baseApiUrl}${orderUrl}/${orderId}/lines`,
          {
              product: event.product,
              quantity: event.quantity
          },
          {
            params
          }
        ).pipe(map(order => {
            order.lines = order.lines.map(line => {
                line.product = applyTranslations([line.product])[0]
                return line
            })
            return order
        }))
    }

    public deleteLine(orderId: string, lineId: string, customerId: string, includeExtraCosts?: boolean): Observable<ApiOrder> {
      let params = new HttpParams()
        .set('customerId', customerId)

      if (includeExtraCosts) {
        params = params.set('includeExtraCosts', includeExtraCosts.toString())
      }

      return this.http.delete<ApiOrder>(
          `${environment.baseApiUrl}${orderUrl}/${orderId}/lines/${lineId}`,
          {
            params
          }
      ).pipe(map(order => {
          order.lines = order.lines.map(line => {
              line.product = applyTranslations([line.product])[0]
              return line
          })
          return order
      }))
    }
}
